import React from 'react';
import useProtocolOperations from 'components/canvas/components/nodes/components/protocol-node/hooks/use-protocol-operations';
import { usePrevious } from 'hooks';
import { SurfaceNodeUnion, SurfaceProtocolNode } from 'graphql/types';
import { Position } from 'types';
import { PROTOCOL_PADDING } from 'components/canvas/components/nodes/components/protocol-node/index';
import { isNull } from 'lodash';

export default function useProtocolEventListeners(
  protocolNode: SurfaceProtocolNode,
) {
  const containingNode = protocolNode.contains;

  const previousContainingNode = usePrevious(protocolNode.contains);

  const position = protocolNode.position as Position;

  const { findProtocolContainingNodeShape } = useProtocolOperations();

  React.useEffect(() => {
    const surfaceNodeAddedToProtocol =
      !previousContainingNode?.id && containingNode?.id;

    const surfaceNodeEjectedFromProtocol =
      previousContainingNode?.id && !containingNode?.id;

    if (surfaceNodeAddedToProtocol && containingNode?.id) {
      const shapeInstance = findProtocolContainingNodeShape(protocolNode);

      if (shapeInstance) {
        shapeInstance.x(position.x + PROTOCOL_PADDING);
        shapeInstance.y(position.y + PROTOCOL_PADDING);
      }
    }

    if (surfaceNodeEjectedFromProtocol) {
      //If contains was removed
    }
  }, [containingNode?.id, previousContainingNode?.id]);
}

export function useOnNodeAddedToProtocol(
  protocolNode: SurfaceProtocolNode,
  callback: (containingNode: SurfaceNodeUnion) => void,
) {
  const containingNode = protocolNode.contains;

  const previousContainingNode = usePrevious(protocolNode.contains);

  React.useEffect(() => {
    const surfaceNodeAddedToProtocol =
      isNull(previousContainingNode) && containingNode?.id;

    if (surfaceNodeAddedToProtocol && containingNode) {
      callback(containingNode);
    }
  }, [containingNode?.id, previousContainingNode?.id]);
}

export function useOnNodeEjectedFromProtocol(
  protocolNode: SurfaceProtocolNode,
  callback: (previousContainingNode: SurfaceNodeUnion) => void,
) {
  const containingNode = protocolNode.contains;

  const previousContainingNode = usePrevious(protocolNode.contains);

  React.useEffect(() => {
    const surfaceNodeEjectedFromProtocol =
      previousContainingNode?.id && !containingNode?.id;

    if (surfaceNodeEjectedFromProtocol && isNull(containingNode)) {
      callback(previousContainingNode);
    }
  }, [containingNode?.id, previousContainingNode?.id]);
}
